import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import Swal from 'sweetalert2';
import "../css/BookAppointment.css";
import Slide from 'react-reveal/Slide';

export const BookAppointment = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
/*Email js account*/
    emailjs.sendForm('service_43ptm6s', 'template_b5w2edf', form.current, 'UPJ_EZPebgxD1AChS')
      .then((result) => {
          console.log(result.text);
          resetForm();
      }, (error) => {
          console.log(error.text);
      });
  };
  const resetForm = () => {
    form.current.reset(); 
  };
     const Alert=()=>{
        Swal.fire(
            'Good job!😎',
            'Email sent!👍 We will contact you soon!',
            'success'
          )
     }
    return(
        <>
        <Slide left>
        <div className='container'>
            <form ref={form} onSubmit={sendEmail}>
                <h2>Book Appointment</h2>
                <input type="text" name="from_name" id="name" placeholder="Your Name" required></input>
                <input type='email' name="from_email" id="email" placeholder="Email id" required></input>
                <input type='text' name="phone_no" id="phone" placeholder="Phone Number" required></input>
                <textarea id="message" name="message" rows="4" placeholder="Area of concern {Your Message}"></textarea>
                <button type="submit" onClick={Alert}>Submit</button>
            </form>
        </div>
        
        </Slide>
        </>
    )
}
export default BookAppointment;